/**
 * JWT 管理（localStorage）
 *
 * MVP は短命運用前提でリフレッシュトークンを持たない。
 * 期限切れになったら再ログイン。
 */

const TOKEN_KEY = "naturenix.owner.token";
const OWNER_KEY = "naturenix.owner.owner";

export type StoredOwner = {
  email: string;
  display_name: string;
};

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(OWNER_KEY);
}

export function setOwner(o: StoredOwner): void {
  localStorage.setItem(OWNER_KEY, JSON.stringify(o));
}

export function getOwner(): StoredOwner | null {
  const v = localStorage.getItem(OWNER_KEY);
  if (!v) return null;
  try {
    return JSON.parse(v) as StoredOwner;
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  return Boolean(getToken());
}
